<div class="department-page">
  <app-header-style-seven></app-header-style-seven>

  <div class="custom-container">
    <section class="dept-hero">
      <div class="hero-grid">
        <div class="hero-copy">
          <span class="hero-kicker">Engineering Department</span>
          <h1>{{ departmentName }}</h1>
          <p>
            Empowering future electrical engineers through strong fundamentals,
            modern laboratory practice, research orientation, industry exposure,
            and outcome-based learning.
          </p>
        </div>

        <div class="hero-stats">
          <div class="stat-card">
            <span class="stat-label">Established</span>
            <strong>{{ establishedYear }}</strong>
          </div>

          <div class="stat-card">
            <span class="stat-label">Intake</span>
            <strong>{{ intake }}</strong>
          </div>

          <div class="stat-card">
            <span class="stat-label">Programme</span>
            <strong>{{ programmeSummary }}</strong>
          </div>

          <div class="stat-card">
            <span class="stat-label">Contact</span>
            <strong>{{ contactEmail }}</strong>
          </div>
        </div>
      </div>
    </section>

    <section class="notice-bar" aria-label="Admission update">
      <div class="notice-label">Admissions Update</div>
      <div class="notice-track">
        <span>{{ admissionNotice }}</span>
      </div>
    </section>

    <section class="department-shell">
      <aside class="department-sidebar">
        <div class="sidebar-card">
          <span class="sidebar-kicker">Department Menu</span>
          <h2>{{ departmentName }}</h2>

          <div class="tab-list">
            <button
              *ngFor="let tab of tabs"
              type="button"
              class="tab-btn"
              [class.active]="selectedTab === tab.id"
              (click)="selectTab(tab.id)"
            >
              {{ tab.label }}
            </button>
          </div>
        </div>
      </aside>

      <main class="department-main">
        <section class="content-head-card">
          <span class="content-tag">Academic Profile</span>
          <h2>{{ activeTabLabel }}</h2>
          <p>
            Department of Electrical &amp; Electronics Engineering, Fatima Michael
            College of Engineering &amp; Technology, Madurai.
          </p>
        </section>

        <ng-container [ngSwitch]="selectedTab">
          <!-- About -->
          <ng-container *ngSwitchCase="'tab1'">
            <section class="content-card">
              <div class="banner-image">
                <img
                  src="assets/img/page-title/page-title15.jpg"
                  alt="Department of Electrical and Electronics Engineering"
                />
              </div>

              <div class="section-copy">
                <h3>About the Department</h3>
                <p *ngFor="let paragraph of aboutParagraphs">
                  {{ paragraph }}
                </p>
              </div>
            </section>

            <section class="fact-grid">
              <article class="fact-card" *ngFor="let fact of quickFacts">
                <span class="fact-title">{{ fact.title }}</span>
                <p>{{ fact.value }}</p>
              </article>
            </section>
          </ng-container>

          <!-- Vision & Mission -->
          <ng-container *ngSwitchCase="'tab2'">
            <section class="info-grid">
              <article class="info-card emphasis-card">
                <div class="card-icon">
                  <img src="assets/img/vision-icon.png" alt="Vision" />
                </div>
                <h3>Our Vision</h3>
                <p>{{ visionText }}</p>
              </article>

              <article class="info-card emphasis-card">
                <div class="card-icon">
                  <img src="assets/img/mission-icon.png" alt="Mission" />
                </div>
                <h3>Our Mission</h3>
                <div class="stack-list">
                  <p *ngFor="let item of missionPoints">
                    {{ item }}
                  </p>
                </div>
              </article>
            </section>
          </ng-container>

          <!-- PEO -->
          <ng-container *ngSwitchCase="'tab3'">
            <section class="content-card">
              <div class="section-head">
                <h3>Program Educational Objectives (PEO)</h3>
                <p>
                  Broad academic, professional, research, and entrepreneurial
                  outcomes expected from graduates.
                </p>
              </div>

              <div class="numbered-list">
                <article class="number-card" *ngFor="let peo of peos; let i = index">
                  <div class="number-badge">{{ i + 1 }}</div>
                  <p>{{ peo }}</p>
                </article>
              </div>
            </section>
          </ng-container>

          <!-- POs & PSOs -->
          <ng-container *ngSwitchCase="'tab4'">
            <section class="content-card">
              <div class="section-head">
                <h3>Program Outcomes (POs)</h3>
                <p>
                  Knowledge, skills, ethics, and professional capabilities expected
                  from graduates of the programme.
                </p>
              </div>

              <div class="outcome-grid">
                <article class="outcome-card" *ngFor="let item of programOutcomes">
                  <h4>{{ item.title }}</h4>
                  <p>{{ item.description }}</p>
                </article>
              </div>
            </section>

            <section class="content-card">
              <div class="section-head">
                <h3>Program Specific Outcomes (PSOs)</h3>
                <p>
                  Department-specific competencies developed through Electrical and
                  Electronics Engineering.
                </p>
              </div>

              <div class="outcome-grid">
                <article class="outcome-card" *ngFor="let item of programSpecificOutcomes">
                  <h4>{{ item.title }}</h4>
                  <p>{{ item.description }}</p>
                </article>
              </div>
            </section>
          </ng-container>

          <!-- Programme Offered -->
          <ng-container *ngSwitchCase="'tab14'">
            <section class="content-card">
              <div class="section-head">
                <h3>Programmes Offered</h3>
                <p>Current academic programme details under the department.</p>
              </div>

              <div class="table-wrap">
                <table class="info-table">
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Programme Name</th>
                      <th>Duration</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let programme of programmes">
                      <td>{{ programme.sno }}</td>
                      <td>{{ programme.name }}</td>
                      <td>{{ programme.duration }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>
          </ng-container>

          <!-- Laboratory Facilities -->
          <ng-container *ngSwitchCase="'tab5'">
            <section class="content-card">
              <div class="section-head">
                <h3>Laboratory Facilities</h3>
                <p>
                  Practical learning spaces supporting electrical machines,
                  circuits, measurements, power electronics, control systems,
                  and embedded applications.
                </p>
              </div>

              <ng-container *ngIf="labs.length > 0; else noLabData">
                <div class="lab-grid">
                  <article class="lab-card" *ngFor="let lab of labs">
                    <div class="lab-media">
                      <img [src]="lab.image" [alt]="lab.title" />
                    </div>
                    <div class="lab-body">
                      <h4>{{ lab.title }}</h4>
                      <p>{{ lab.description }}</p>
                    </div>
                  </article>
                </div>
              </ng-container>

              <ng-template #noLabData>
                <div class="section-copy">
                  <p>Laboratory facility details will be updated soon.</p>
                </div>
              </ng-template>
            </section>
          </ng-container>

          <!-- Association Activities -->
          <ng-container *ngSwitchCase="'tab6'">
            <section class="content-card">
              <div class="section-head">
                <h3>Association Activities</h3>
                <p>
                  Student association events, technical activities, presentations,
                  and departmental engagement initiatives.
                </p>
              </div>

              <div class="table-wrap">
                <table class="info-table">
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Activity</th>
                      <th>Date</th>
                      <th>Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of associationActivities">
                      <td>{{ item.sno }}</td>
                      <td>{{ item.activity }}</td>
                      <td>{{ item.date }}</td>
                      <td>{{ item.description }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>
          </ng-container>

          <!-- MoUs -->
          <ng-container *ngSwitchCase="'tab7'">
            <section class="content-card">
              <div class="section-head">
                <h3>MoU's</h3>
                <p>
                  Collaborations supporting student development, training, and
                  research engagement.
                </p>
              </div>

              <div class="table-wrap">
                <table class="info-table">
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Organization</th>
                      <th>Date of Signing</th>
                      <th>Purpose</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of mous">
                      <td>{{ item.sno }}</td>
                      <td>{{ item.organization }}</td>
                      <td>{{ item.date }}</td>
                      <td>{{ item.purpose }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>
          </ng-container>

          <!-- Placement Record -->
        <!-- Placement Record -->
<ng-container *ngSwitchCase="'tab8'">
  <section class="content-card">
    <div class="section-head">
      <h3>Placement Record</h3>
      <p>Selected placement outcomes of students from the department.</p>
    </div>

    <div class="table-wrap">
      <table class="info-table">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Batch</th>
            <th>Name</th>
            <th>Designation</th>
            <th>Company Name</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of placementRecords">
            <td>{{ item.sno }}</td>
            <td>{{ item.batch || '-' }}</td>
            <td>{{ item.studentName }}</td>
            <td>{{ item.designation }}</td>
            <td>{{ item.companyName }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</ng-container>
          <!-- Industrial Visit -->
          <ng-container *ngSwitchCase="'tab9'">
            <section class="content-card">
              <div class="section-head">
                <h3>Industrial Visit</h3>
                <p>
                  Industrial exposure visits that support practical learning and
                  real-world engineering understanding.
                </p>
              </div>

              <div class="lab-grid">
                <article class="lab-card" *ngFor="let visit of industrialVisits">
                  <div class="lab-media">
                    <img [src]="visit.image" [alt]="visit.title" />
                  </div>

                  <div class="lab-body">
                    <h4>{{ visit.title }}</h4>
                    <p>{{ visit.description }}</p>
                  </div>
                </article>
              </div>
            </section>
          </ng-container>

          <!-- Value Added Courses -->
          <ng-container *ngSwitchCase="'tab10'">
            <section class="content-card">
              <div class="section-head">
                <h3>Value Added Courses</h3>
                <p>
                  Additional training programmes that enhance technical and
                  professional readiness.
                </p>
              </div>

              <div class="table-wrap">
                <table class="info-table">
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Course Name</th>
                      <th>Course Details</th>
                      <th>Commence Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of valueAddedCourses">
                      <td>{{ item.sno }}</td>
                      <td>{{ item.courseName }}</td>
                      <td>{{ item.courseDetails }}</td>
                      <td>{{ item.commenceDate }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>
          </ng-container>

          <!-- Alumni -->
    <ng-container *ngSwitchCase="'tab11'">
  <section class="content-card">
    <div class="section-head">
      <h3>Alumni</h3>
      <p>Distinguished alumni from the department.</p>
    </div>

    <ng-container *ngIf="alumniRecords.length > 0; else noAlumniData">
      <div class="alumni-grid">
        <article class="alumni-card" *ngFor="let alumni of alumniRecords">
          <div class="alumni-photo-wrap">
            <img [src]="alumni.image" [alt]="alumni.name" class="alumni-photo" />
          </div>

          <div class="alumni-content">
            <h4>{{ alumni.name }}</h4>
            <p><strong>Batch:</strong> {{ alumni.batch }}</p>
            <p><strong>Designation:</strong> {{ alumni.role }}</p>
            <p><strong>Organization:</strong> {{ alumni.company }}</p>
            <p class="alumni-quote">{{ alumni.quote }}</p>
          </div>
        </article>
      </div>
    </ng-container>

    <ng-template #noAlumniData>
      <div class="section-copy">
        <p>Alumni details will be updated soon.</p>
      </div>
    </ng-template>
  </section>
</ng-container>

   <ng-container *ngSwitchCase="'tab12'">
  <section class="content-card">
    <div class="section-head">
      <h3>Achievements</h3>
      <p>
        The Department of Electrical & Electronics Engineering takes pride in the
        outstanding achievements of its faculty members in academic excellence,
        professional recognition, and programme coordination.
      </p>
    </div>

    <div class="lab-grid achievements-grid">
      <article class="lab-card" *ngFor="let item of achievements">
        <div class="lab-image-wrap">
          <img [src]="item.image" [alt]="item.title" class="lab-image" />
        </div>
        <div class="lab-content">
          <h4>{{ item.title }}</h4>
          <p>{{ item.description }}</p>
        </div>
      </article>
    </div>
  </section>
</ng-container>
          <!-- NPTEL -->
          <ng-container *ngSwitchCase="'tab13'">
            <section class="content-card">
              <div class="section-head">
                <h3>NPTEL</h3>
                <p>Faculty NPTEL certification details will be listed here.</p>
              </div>

              <ng-container *ngIf="nptelRecords.length > 0; else noNptelData">
                <div class="table-wrap">
                  <table class="info-table">
                    <thead>
                      <tr>
                        <th>Sl. No.</th>
                        <th>Name of the Staff</th>
                        <th>Subject</th>
                        <th>Grade</th>
                        <th>Session</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of nptelRecords; let i = index">
                        <td>{{ i + 1 }}</td>
                        <td>{{ item.staffName }}</td>
                        <td>{{ item.subject }}</td>
                        <td>{{ item.grade }}</td>
                        <td>{{ item.session }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </ng-container>

              <ng-template #noNptelData>
                <div class="section-copy">
                  <p>NPTEL details will be updated soon.</p>
                </div>
              </ng-template>
            </section>
          </ng-container>

          <!-- Research -->
       <ng-container *ngSwitchCase="'tab15'">
  <section class="content-card">
    <div class="section-head">
      <h3>Conference</h3>
      <p>
        Conference publications and paper presentations by faculty
        members of the department.
      </p>
    </div>

    <ng-container *ngIf="conferenceRecords.length > 0; else noConferenceData">
      <div class="table-wrap">
        <table class="info-table">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Event</th>
              <th>Name of the Participant</th>
              <th>Date</th>
              <th>College Name</th>
              <th>Title</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of conferenceRecords">
              <td>{{ item.sno }}</td>
              <td>{{ item.conferenceName }}</td>
              <td>
                <div *ngFor="let author of item.authors">
                  {{ author }}
                </div>
              </td>
              <td>{{ item.date }}</td>
              <td>{{ item.collegeName }}</td>
              <td>{{ item.paperTitle }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>

    <ng-template #noConferenceData>
      <div class="section-copy">
        <p>Conference details will be updated soon.</p>
      </div>
    </ng-template>
  </section>

  <section class="content-card">
    <div class="section-head">
      <h3>Journal Publication</h3>
      <p>
        Journal publications contributed by faculty members of the department.
      </p>
    </div>

    <ng-container *ngIf="journalPublications.length > 0; else noJournalData">
      <div class="table-wrap">
        <table class="info-table">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Event</th>
              <th>Name of the Participant</th>
              <th>Date</th>
              <th>Journal Name</th>
              <th>Title</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of journalPublications">
              <td>{{ item.sno }}</td>
              <td>{{ item.event }}</td>
              <td>
                <div *ngFor="let author of item.authors">
                  {{ author }}
                </div>
              </td>
              <td>{{ item.date }}</td>
              <td>{{ item.journalName }}</td>
              <td>{{ item.title }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>

    <ng-template #noJournalData>
      <div class="section-copy">
        <p>Journal publication details will be updated soon.</p>
      </div>
    </ng-template>
  </section>
</ng-container>
        </ng-container>
      </main>
    </section>

    <section class="bottom-cta">
      <article class="cta-card contact-card">
        <span class="cta-kicker">Contact</span>
        <h3>Department Contact</h3>
        <p>
          Head of Department,<br />
          Department of Electrical &amp; Electronics Engineering,<br />
          Fatima Michael College of Engineering &amp; Technology,<br />
          Madurai.
        </p>
        <a class="text-link" href="mailto:eeehod@fmcet.ac.in">
          {{ contactEmail }}
        </a>
      </article>

      <article class="cta-card action-card">
        <span class="cta-kicker">Admissions</span>
        <h3>Welcome to Department of Electrical &amp; Electronics Engineering</h3>
        <p>
          Become an Electrical &amp; Electronics Engineer and build the future of
          power, control, automation, and energy systems.
        </p>
<a
  class="apply-btn"
  routerLink="/inquiry"
>
  Apply Now
</a>
      </article>
    </section>
  </div>
</div>